// extracted by mini-css-extract-plugin
export default {"container":"Damages_container__JTsW6","page":"Damages_page__utfTJ","section":"Damages_section__qgTsj"};